import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import Emoji from "../components/Emoji";


const ThankYouPage = () => {
  const [loading, setLoading] = useState(true);
  const [canActivate, setCanActivate] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkEligibility = async () => {
      const user = getAuth().currentUser;
      if (!user) {
        navigate('/');
        return;
      }

      try {
        const userRef = doc(db, 'users', user.uid);
        const userSnap = await getDoc(userRef);

        if (!userSnap.exists()) {
          navigate('/');
          return;
        }

        const data = userSnap.data();

        // Security: Only allow if user is still on trial
        if (data.plan === 'trial') {
          setCanActivate(true);
        } else {
          navigate('/');
        }
      } catch (err) {
        console.error('Error checking user plan:', err);
        navigate('/');
      } finally {
        setLoading(false);
      }
    };

    // ✅ Removed fragile referrer check
    checkEligibility();
  }, [navigate]);

  const handleActivate = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      const userRef = doc(db, 'users', user.uid);
      await updateDoc(userRef, {
        plan: 'paid',
        unlocked: true,
      });

      navigate('/dashboard');
    } catch (err) {
      console.error('Activation failed:', err);
      alert('Something went wrong. Please try again later.');
    }
  };

  if (loading) return <div style={styles.spinner}><Emoji symbol="🔄" label="refresh" /> Checking subscription...</div>;

  return (
    <div style={styles.container}>
      <Emoji symbol="🎉" label="party popper" className="mr-1" /><h1> Thank You for Subscribing!</h1>
      <p>Your payment was successful. Click below to activate your account.</p>
      {canActivate ? (
        <button style={styles.button} onClick={handleActivate}>
          Activate and Start Learning
        </button>
      ) : (
        <p><Emoji symbol="🔒" label="locked" /> You are not eligible to activate this way.</p>
      )}
    </div>
  );
};

export default ThankYouPage;

const styles = {
  container: {
    maxWidth: '600px',
    margin: '60px auto',
    textAlign: 'center',
    fontFamily: 'Georgia, serif',
    padding: '20px',
    backgroundColor: '#f9f9f9',
    borderRadius: '10px',
    boxShadow: '0 0 12px rgba(0,0,0,0.1)',
  },
  button: {
    backgroundColor: '#28a745',
    color: 'white',
    border: 'none',
    padding: '12px 24px',
    fontSize: '1rem',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  spinner: {
    textAlign: 'center',
    fontSize: '1.2rem',
    padding: '40px',
  },
};
